import { useEffect, useState } from 'react'

export function useOrderUpdates(orderId, token) {
    const [revision, setRevision] = useState(0)

    useEffect(() => {
        if (!orderId || !token) return
        let disposed = false
        let socket
        let reconnectTimer
        const refresh = () => { if (!disposed) setRevision(value => value + 1) }
        const onFocus = () => { if (document.visibilityState === 'visible') refresh() }
        const connect = () => {
            const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
            socket = new WebSocket(`${protocol}://${window.location.host}/api/ws?token=${encodeURIComponent(token)}`)
            socket.onopen = refresh
            socket.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data)
                    if (!['diagnostic_changed', 'orders_changed'].includes(data.type)) return
                    if (data.orderId != null && Number(data.orderId) !== Number(orderId)) return
                    refresh()
                } catch { /* Ignore unrelated or malformed messages. */ }
            }
            socket.onclose = () => {
                if (!disposed) reconnectTimer = setTimeout(connect, 3000)
            }
        }
        connect()
        window.addEventListener('focus', onFocus)
        document.addEventListener('visibilitychange', onFocus)
        // Recover missed events even if a proxy silently drops the connection.
        const fallback = setInterval(onFocus, 15000)
        return () => {
            disposed = true
            clearTimeout(reconnectTimer)
            clearInterval(fallback)
            window.removeEventListener('focus', onFocus)
            document.removeEventListener('visibilitychange', onFocus)
            socket?.close()
        }
    }, [orderId, token])

    return revision
}
